import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RedirectService {
  redirectTo(url: string): void {
    console.log('🚨 REDIRECT SERVICE CALLED 🚨');
    console.log('Redirecting to:', url);
    console.log('Current URL:', window.location.href);
    console.trace('Stack trace for redirect');
    window.location.href = url;
  }
}
